import { en_GB, es_ES } from 'ng-zorro-antd/i18n';
import { enGB, es as esEs } from 'date-fns/locale';
import { LanguageCode, LanguagesMap } from '../models/i18n.models';

// Define a map of available languages and their corresponding locales
export const LANGUAGES_MAP: LanguagesMap = {
  en: {
    locale: en_GB,
    dateLocale: enGB,
  },
  es: {
    locale: es_ES,
    dateLocale: esEs,
  },
  // Add more languages as needed
};

export const AVAILABLE_LANGUAGES: LanguageCode[] = ['en', 'es'];
export const FALLBACK_LANGUAGE: LanguageCode = 'es';
export const BASE_URL_i18n: string = '/assets/i18n';
